<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
    .main-area(v-if="areas.main && areas.main.length")
      template(v-for="(section, index) in areas.main" v-if="isAllowed(section.key, 'main')")
        Heading.container.mx-auto(v-if="section.key === 'heading'" :section="section")
        Post.container.mx-auto(v-if="section.key === 'post'" :section="section")
        CategoryPosts.container.mx-auto(v-if="section.key === 'categoryposts'" :section="section")
        ImageSection.container.mx-auto(v-if="section.key === 'image'" :section="section")
        PhotoAlbum.container.mx-auto(v-if="section.key === 'photoalbum'" :section="section")
        Slider(v-if="section.key === 'slider'" :section="section")
        LoginForm.container.mx-auto(v-if="section.key === 'login'" :section="section")
        ContactForm.container.mx-auto(v-if="section.key === 'form'" :section="section")
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/sections/Heading';
import Slider from '@/sections/Slider';
import Post from '@/sections/Post';
import Banner from '@/sections/Banner';
import CategoryPosts from '@/sections/CategoryPosts';
import ImageSection from '@/sections/Image';
import PhotoAlbum from '@/sections/PhotoAlbum';
import ContactForm from '@/extensions/forms/sections/Form';

export default {
  name: 'ContentPageInvers',
  extends: Page,
  components: {
    Heading,
    Slider,
    Post,
    Banner,
    CategoryPosts,
    ImageSection,
    PhotoAlbum,
    ContactForm
  },
  methods: {
    isAllowed(key, area = 'main') {
      switch (area) {
        // case 'header':
        //   return ['banner', 'slider'].includes(key);

        case 'main':
        default:
          return ['heading', 'post', 'categoryposts', 'image', 'photoalbum', 'slider', 'form'].includes(key);
      }
    }
  },
  mounted () {
    document.body.classList.add('inverted')
  },
  destroyed () {
    document.body.classList.remove('inverted')
  }
};
</script>

<style lang="sass">

.inverted #app
  --color-primary: #fff !important
  --color-hp-bg: #7BA745 !important
  --color-base-text: #fff !important
  --color-link-sidebar-menu: #3c3d3b !important
  --color-link-hover-sidebar-menu: #7BA745 !important
  
  .header-wrap .brand-title .inner,
  .heading-field .subtitle
    color: var(--color-primary)

</style>
